import { Box } from "@mui/material";
import NavigationItem from "./NavigationItem";

export default function DesktopMenu({ pages, navigate, location, theme }) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {pages.map((page) => (
        <NavigationItem
          key={page.title}
          page={page}
          navigate={navigate}
          location={location}
          theme={theme}
        />
      ))}
    </Box>
  );
}
